import React from 'react';
import { Container, Row } from 'react-bootstrap';
import IProjectItem from '../../models/ProjectItem';
import ProjectItem from './HomeItem';
import "../../assets/scss/home/home-content.scss";


interface props {
    list: IProjectItem[]
}
function HomeContent(props: props) {

    const list: JSX.Element[] = props.list.map((item: IProjectItem, index: number) => {
        return (
            <Row key={index}>
                <ProjectItem title={item.title} meta={item.meta} description={item.description} url={item.url} />
            </Row>
        )
    });

    return (
        <Container className="home-content">
            {list}
        </Container>
    );
}

export default HomeContent;